import { Form } from '@/components/ui/form';
import useLandHook from '../../hooks/useLandHook';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import SelectControl from '@/components/controls/select-control';
import { ScrollArea } from '@/components/ui/scroll-area';
import CheckboxControl from '@/components/controls/checkbox-control';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { notSelected, selected } from '../../constants/land';
import { Actions } from './actions';
import { Infos } from './info/Info';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AllCounterTable } from './tables/AllContour';

export default function LandSingle() {
  const { t } = useTranslation();
  const {
    tab,
    form,
    open,
    plants,
    table,
    options,
    landById,
    contourList,
    landByIdLoading,
    fields,
    setTab,
    setOpen,
    onSubmit,
  } = useLandHook();

  const isCropSelected = !!form.watch('crop');
  const tabOptions = isCropSelected ? selected : notSelected;
  const unmergedFields = fields?.filter((el) => el.merged !== true) || [];

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="p-10 h-full flex flex-col gap-[29px]">
          <Actions
            setOpen={setOpen}
            regnum={landById.regnum}
            id={landById.id}
            isLoading={landByIdLoading}
            isLoadingPro={false}
            onSubmit={onSubmit}
            setTab={setTab}
            isSubmit={isCropSelected}
            show={
              !!contourList?.length &&
              contourList?.some((item) => item?.merged === false)
            }
          />
          <Infos items={landById} isLoading={landByIdLoading} />
          <hr />
          <Tabs value={tab} onValueChange={setTab} className="w-full">
            <TabsList className="grid w-[776px] grid-cols-3">
              {tabOptions.map((item) => (
                <TabsTrigger value={item.value} key={item.value}>
                  {t(item.label)}
                </TabsTrigger>
              ))}
            </TabsList>
            {tabOptions.map((item) => (
              <TabsContent value={item.value} key={item.value}>
                <ScrollArea className="h-[calc(100vh-550px)]">
                  <AllCounterTable table={table} />
                </ScrollArea>
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </form>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="[&>button]:hidden sm:max-w-[432px]"
          onInteractOutside={(e) => e.preventDefault()}
        >
          <DialogHeader>
            <DialogTitle>{t('contour.selection')}</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2.5">
              <p>{t('cadastral.number')}</p>
              <span>{fields?.[0]?.parent_cad_number}</span>
            </div>

            <SelectControl
              control={form.control}
              name="crop"
              label={t('crop')}
              options={options || []}
            />

            <ScrollArea className="h-[calc(100vh-500px)]">
              <div className="px-4 py-3 bg-gray-100 rounded-[10px] flex flex-col gap-2">
                {unmergedFields.map((item) => {
                  const originalIndex = fields.findIndex(
                    (el) => el.id === item.id,
                  );
                  return (
                    <div className="grid grid-cols-12 gap-4" key={item.id}>
                      <div className="flex items-start col-span-4 gap-3">
                        <CheckboxControl
                          control={form.control}
                          name={`value.${originalIndex}.selected`}
                        />
                        <p>{item?.contour_number}</p>
                      </div>
                      <div className="flex items-start col-span-4 gap-3">
                        <p>{item.area || 0} ga</p>
                      </div>
                      <div className="flex items-start col-span-4 gap-3">
                        <p>
                          {plants?.find(
                            (plant) => plant?.id === String(item?.plant_id),
                          )?.name || '-'}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </ScrollArea>
          </div>
          <DialogFooter>
            <Button
              className="w-full rounded-xl"
              variant="outline"
              type="submit"
              onClick={() => {
                if (isCropSelected) {
                  setTab('selected');
                }
                setOpen(false);
              }}
            >
              {t('close')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Form>
  );
}
